import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ErrorService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { first, takeUntil } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MatHeaderRow, MatTable, MatTableDataSource } from '@angular/material/table';
import { ResourcesService } from '@shared/services/resources.service';

export type ExportFormat = 'excel' | 'pdf';

@Component({
  selector: 'app-new-fixed-assets',
  templateUrl: './new-fixed-assets.component.html',
  styleUrls: ['./new-fixed-assets.component.scss']
})
export class NewFixedAssetsComponent implements OnInit, OnDestroy {
  private _unsubscribeAll$ = new Subject<boolean>();

  items: MenuItem[] = [];
  loading = true;
  constructor(
    private translate: TranslateService,
    public router: Router,
    public route: ActivatedRoute,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private _errorService: ErrorService,
    private _resourcesService: ResourcesService
  ) {}

  searchValue = '';
  changeNewContant = false;
  laddaSearchProgress: boolean | number = false;

  assetsList: any[] = [];
  @ViewChild('exportModal', { static: true }) exportModal: TemplateRef<any>;
  @ViewChild('formAddEditModal', { static: true }) formModal: TemplateRef<any>;
  modalRef: BsModalRef | null;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['select', 'name', 'assetcode', 'Status'];
  dataSource = new MatTableDataSource<any>([]);
  selection = new SelectionModel<any>(true, []);

  formType = 'add';
  assetForm: FormGroup;
  saveContant = false;

  selectedAction: string | null = null;

  disableActivate = false;
  disableInactivate = false;

  // Filter (Display All / Active / Inactive)
  filterList: string[] = ['Display All', 'Active', 'Inactive'];
  selectedDisplayAction: string = 'Display All';

  // Import modal refs/state
  @ViewChild('importModal', { static: true }) importModal: TemplateRef<any>;
  selectedFile: File | null = null;
  isProcessing = false;
  importCompleted = false;
  progressPercentage = 0;
  processedItems = 0;
  totalItems = 0;
  batchSize = 50;
  importData: any[] = [];
  errorItems: any[] = [];
  validItems: any[] = [];
  insertedItems: any[] = [];
  skippedItems: any[] = [];
  private processingTimeout: any;
  private isCancelled = false;
  tamplateloading = false;

  ngOnInit() {
    this.initializeMenuItems();
    this.getList();
    this.initForm();
    this.assetForm.valueChanges.pipe(takeUntil(this._unsubscribeAll$)).subscribe(() => {
      this.changeNewContant = true;
    });
  }

  ngOnDestroy() {
    this._unsubscribeAll$.next(true);
    this._unsubscribeAll$.complete();
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  Edit(row: any) {
    this.formType = 'edit';
    this.initForm();
    this.getById(row.fixedassetid);
    this.openModal();
  }

  AddNewItem() {
    this.formType = 'add';
    this.initForm();
    this.openModal();
  }

  openModal() {
    const configs = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
      animated: false
    };
    this.modalRef = this.modalService.show(this.formModal, configs);
  }

  closeAddEditModal() {
    if (!this.changeNewContant) {
      this.modalRef?.hide();
    } else this.newMessage(144, 'ClosePopup');
  }

  ClosePopup() {
    this.modalRef?.hide();
    this.changeNewContant = false;
  }

  openAnyModal(modal: TemplateRef<any>) {
    const configs = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
      animated: false
    };
    this.modalRef = this.modalService.show(modal, configs);
  }

  getList() {
    this.searchValue = '';
    this._resourcesService
      .getfixedassets()
      .pipe(takeUntil(this._unsubscribeAll$), first())
      .subscribe((result: any) => {
        this.assetsList = result.data || [];
        this.dataSource = new MatTableDataSource<any>(this.assetsList);
        this.dataSource.sort = this.sort;
        this.loading = false;
      });
  }

  getById(id: string) {
    this._resourcesService
      .getfixedassetbyid(id)
      .pipe(takeUntil(this._unsubscribeAll$), first())
      .subscribe((result: any) => {
        const asset = result.data;
        if (!asset) return;
        const controls = this.assetForm.controls;
        Object.keys(controls).forEach((key) => {
          if (asset[key] != null) {
            this.assetForm.get(key)?.setValue(asset[key]);
          }
          this.changeNewContant = false;
        });
      });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  checkboxLabel(row): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Display All / Active / Inactive
  onFilterChange(filterValue: string) {
    if (!filterValue || filterValue === 'Display All') {
      this.selectedDisplayAction = 'Display All';
      this.dataSource.data = [...this.assetsList];
    } else if (filterValue === 'Active') {
      this.selectedDisplayAction = 'Active';
      this.dataSource.data = this.assetsList.filter((item) => item.isvalid === true);
    } else if (filterValue === 'Inactive') {
      this.selectedDisplayAction = 'Inactive';
      this.dataSource.data = this.assetsList.filter((item) => item.isvalid === false);
    }
  }

  private initForm(): void {
    this.assetForm = this.fb.group({
      fixedassetid: new FormControl(null),
      assetcode: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required]),
      description: new FormControl(null),
      icon: new FormControl(null),
      photo: new FormControl(null),
      isvalid: new FormControl(true)
    });
  }

  setTumbnail(data) {
    this.assetForm.get('photo')?.setValue(data);
  }
  setFileName(data) {
    this.assetForm.get('photo')?.setValue(data);
  }

  saveAddEdit() {
    this.laddaSearchProgress = 1;
    const controls = this.assetForm.controls;
    Object.keys(controls).forEach((key) => controls[key].markAsTouched());

    if (this.assetForm.status === 'VALID') {
      this.saveContant = false;
      const value = this.assetForm.value;
      const req$ = !value.fixedassetid
        ? this._resourcesService.addfixedasset(value)
        : this._resourcesService.editfixedasset(value);

      req$.pipe(takeUntil(this._unsubscribeAll$), first()).subscribe(
        (result: any) => {
          if (result.isSuccess) {
            this.newMessage(!value.fixedassetid ? 93 : 4, '');
            this.changeNewContant = false;
            this.closeAddEditModal();
          } else {
            this.newMessage(77, '');
          }
          this.getList();
          this.laddaSearchProgress = false;
          this.changeNewContant = false;
          this.saveContant = false;
        },
        () => {
          this.laddaSearchProgress = false;
        }
      );
    } else {
      this.saveContant = true;
      window.scrollTo(0, 0);
      this.laddaSearchProgress = false;
      this.newMessage(3, '');
    }
  }

  deleteSelected() {
    if (this.selection.selected.length === 0) {
      this.newMessage(60, 'error');
      return;
    }
    const ids = this.selection.selected.map((x) => x.fixedassetid);
    this._resourcesService
      .deletefixedassets(ids)
      .pipe(takeUntil(this._unsubscribeAll$), first())
      .subscribe((result: any) => {
        this.newMessage(result.isSuccess ? 54 : 55, '');
        this.selection = new SelectionModel<any>(true, []);
        this.getList();
        this.laddaSearchProgress = false;
        this.changeNewContant = false;
        this.saveContant = false;
      });
  }

  updateActionAvailability() {
    const selected = this.selection.selected;
    if (!selected || selected.length === 0) {
      this.disableActivate = false;
      this.disableInactivate = false;
    } else {
      const allActive = selected.every((item) => item.isvalid === true);
      const allInactive = selected.every((item) => item.isvalid === false);
      if (allActive) {
        this.disableActivate = true;
        this.disableInactivate = false;
      } else if (allInactive) {
        this.disableActivate = false;
        this.disableInactivate = true;
      } else {
        this.disableActivate = true;
        this.disableInactivate = true;
      }
    }
    this.updateMenuItems();
  }

  initializeMenuItems() {
    this.items = [
      {
        label: this.translate.instant('Delete'),
        icon: 'pi pi-times',
        disabled: false,
        command: () => this.deleteSelected()
      },
      {
        label: this.translate.instant('Activate'),
        icon: 'pi pi-check',
        disabled: this.disableActivate,
        command: () => this.activeSelected()
      },
      {
        label: this.translate.instant('Deactivate'),
        icon: 'pi pi-ban',
        disabled: this.disableInactivate,
        command: () => this.inactiveSelected()
      }
    ];
  }

  updateMenuItems() {
    this.initializeMenuItems();
  }

  activeSelected() {
    const ids = this.selection.selected.map((x) => x.fixedassetid);
    if (ids.length === 0) return;
    swal
      .fire({
        title: `Are you sure you want to activate the selected items?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#6FBDC1'
      })
      .then((res) => {
        if (!res.value) return;
        this._resourcesService
          .activefixedassets(ids)
          .pipe(takeUntil(this._unsubscribeAll$), first())
          .subscribe(() => {
            this.selection = new SelectionModel<any>(true, []);
            this.getList();
          });
      });
  }

  inactiveSelected() {
    const ids = this.selection.selected.map((x) => x.fixedassetid);
    if (ids.length === 0) return;
    swal
      .fire({
        title: `Are you sure you want to inactivate the selected items?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#6FBDC1'
      })
      .then((res) => {
        if (!res.value) return;
        this._resourcesService
          .Inactivefixedassets(ids)
          .pipe(takeUntil(this._unsubscribeAll$), first())
          .subscribe(() => {
            this.selection = new SelectionModel<any>(true, []);
            this.getList();
          });
      });
  }

  async Export(format: ExportFormat = 'excel'): Promise<void> {
    const dataToExport = this.dataSource.filteredData;
    const exportData = dataToExport.map((item: any) => ({
      Name: item.name,
      Code: item.assetcode,
      Status: item.isvalid ? 'Active' : 'Inactive'
    }));
    if (format === 'excel') await this.exportToExcel(exportData);
    else await this.exportToPDF(exportData);
  }

  private async exportToExcel(data: any[]): Promise<void> {
    const fileName = 'Fixed Assets.xlsx';
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    FileSaver.saveAs(blob, fileName);
  }

  private async exportToPDF(data: any[]): Promise<void> {
    const fileName = 'Fixed Assets.pdf';
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text('Fixed Assets Exported Data Report', 14, 20);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
    const tableColumns = ['Name', 'Code', 'Status'];
    const tableRows = data.map((item) => [item.Name, item.Code, item.Status]);
    autoTable(doc, {
      head: [tableColumns],
      body: tableRows,
      startY: 40,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [63, 81, 181], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 40 }
    });
    const pdfBlob = doc.output('blob');
    FileSaver.saveAs(pdfBlob, fileName);
  }

  newMessage(id, action) {
    this._errorService.changeMessage({ id: id, action: action });
  }

  // Import flow
  onImportClick(): void {
    this.openImportModal();
  }

  openImportModal() {
    this.resetImportState();
    const configs = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
      animated: false
    };
    this.modalRef = this.modalService.show(this.importModal, configs);
  }

  closeImportModal(): void {
    if (this.isProcessing) {
      if (confirm('Import is in progress. Are you sure you want to cancel?')) {
        this.cancelImport();
      } else {
        return;
      }
    }
    this.modalRef?.hide();
    this.resetImportState();
  }

  resetImportState(): void {
    this.selectedFile = null;
    this.isProcessing = false;
    this.importCompleted = false;
    this.progressPercentage = 0;
    this.processedItems = 0;
    this.totalItems = 0;
    this.importData = [];
    this.errorItems = [];
    this.validItems = [];
    this.insertedItems = [];
    this.skippedItems = [];
    this.isCancelled = false;
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const data: Uint8Array = new Uint8Array(e.target.result);
          const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
          this.importData = (rawData as any[]).map((item, index) => ({
            fixedassetid: null,
            assetcode: item.Code || '',
            name: item.Name || '',
            description: '',
            icon: '',
            photo: '',
            isvalid: (item.Status || '').toString().toLowerCase() === 'active',
            _rowIndex: index + 2
          }));
          this.validateData();
        } catch (error) {
          this.selectedFile = null;
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }

  getFileSizeDisplay(): string {
    if (!this.selectedFile) return '';
    const fileSizeKB = this.selectedFile.size / 1024;
    return fileSizeKB < 1024 ? `${fileSizeKB.toFixed(2)} KB` : `${(fileSizeKB / 1024).toFixed(2)} MB`;
  }

  validateData(): void {
    this.errorItems = [];
    this.validItems = [];
    this.importData.forEach((item: any) => {
      let isValid = true;
      const rowError: any = { rowNumber: item._rowIndex, assetcode: item.assetcode, error: '' };
      if (!item.assetcode) {
        rowError.error += 'Asset code is required. ';
        isValid = false;
      }
      if (item.assetcode && item.assetcode.length > 50) {
        rowError.error += 'Asset code max length is 50 character';
        isValid = false;
      }
      if (!item.name) {
        rowError.error += 'Name is required. ';
        isValid = false;
      }
      if (item.name && item.name.length > 100) {
        rowError.error += 'name max length is 100 character';
        isValid = false;
      }
      if (isValid) this.validItems.push(item); else this.errorItems.push(rowError);
    });
  }

  startImport(): void {
    if (this.importData.length === 0) return;
    if (this.validItems.length === 0) {
      this.newMessage(229, '');
      return;
    }
    const dataToImport = this.errorItems.length > 0 ? this.validItems : this.importData;
    this.totalItems = dataToImport.length;
    this.processedItems = 0;
    this.progressPercentage = 0;
    this.isProcessing = true;
    this.isCancelled = false;
    this.processBatch(dataToImport, 0);
  }

  processBatch(data: any[], startIndex: number): void {
    if (this.isCancelled) return;
    const endIndex = Math.min(startIndex + this.batchSize, data.length);
    const batch = data.slice(startIndex, endIndex);
    this.saveFixedAssetsBatch(batch)
      .then((response: any) => {
        const inserted = response?.data?.inserted || [];
        this.processedItems += inserted.length || batch.length;
        this.progressPercentage = Math.round((this.processedItems / this.totalItems) * 100);
        if (endIndex < data.length && !this.isCancelled) {
          this.processingTimeout = setTimeout(() => this.processBatch(data, endIndex), 100);
        } else if (!this.isCancelled) {
          this.completeImport();
        }
      })
      .catch(() => {
        this.isProcessing = false;
      });
  }

  saveFixedAssetsBatch(batch: any[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this._resourcesService.addfixedassetbatch(batch).subscribe({
        next: (response) => {
          this.insertedItems = response.data?.inserted || [];
          this.skippedItems = response.data?.skipped || [];
          if (this.dataSource && this.dataSource.data && this.insertedItems.length > 0) {
            this.dataSource.data = [...this.dataSource.data, ...this.insertedItems];
          }
          this.importCompleted = true;
          resolve(response);
        },
        error: (err) => reject(err)
      });
    });
  }

  cancelImport(): void {
    this.isCancelled = true;
    if (this.processingTimeout) clearTimeout(this.processingTimeout);
    this.isProcessing = false;
  }

  completeImport(): void {
    this.isProcessing = false;
    this.importCompleted = true;
    this.getList();
  }
}


